/**
 * The name of the record the current screen is showing.
 *
 * A breadcrumb must not be derived from the URL here: the last segment of
 * `/tenants/019fd47f-…` is a uuid, and a uuid in a breadcrumb tells an
 * operator nothing. So detail views publish the record's real name once it has
 * loaded, and the breadcrumb renders that or nothing at all.
 *
 * Module-level state rather than route meta: mutating `route.meta` is not
 * reliably reactive, and the label is transient screen state, not routing
 * configuration.
 */

import { onScopeDispose, readonly, ref, watch, type Ref } from 'vue'

const label = ref('')

export function recordLabel(): Readonly<Ref<string>> {
  return readonly(label)
}

export function clearRecordLabel(): void {
  label.value = ''
}

/** Publishes `source` as the current record label for this scope's lifetime. */
export function useRecordLabel(source: Ref<string | undefined | null>): void {
  watch(
    source,
    (value) => {
      label.value = value ?? ''
    },
    { immediate: true },
  )
  onScopeDispose(clearRecordLabel)
}
